import React from 'react';
import http from '@/services/http';
import { PROFILE_URL, SETTINGS_URL } from './urls';

class ProfileController extends React.Component {
	get = async () => {
		// console.log("getProfile");
		let data;

		try {
			const res = await http.get(PROFILE_URL);
			// console.log(res);
			data = res?.data;
			if (!data?.id) {
				return {
					error: res?.data?.code || true,
				};
			}
		} catch (error) {
			console.log(error);
			return {
				error: true,
			};
		}

		// console.log("zook", data);
		return {
			profile: data,
		};
	};

	edit = async profile => {
		// console.log("editProfile", profile);
		let data;

		try {
			const res = await http.put(PROFILE_URL, { profile });
			// console.log("res from put", res);
			data = res?.data;
		} catch (error) {
			console.log(error);
			return {
				error: true,
			};
		}

		return {
			...data,
		};
	};

	updateOperation = async (cityId, operating, notOperatingReason, warningMessage) => {
		// console.log("updateOperation", cityId, operating, notOperatingReason);
		let data;

		try {
			const res = await http.put(`${SETTINGS_URL}update-operation`, {
				cityId,
				operating,
				notOperatingReason,
				warningMessage,
			});
			// console.log("res from put", res);
			data = res?.data;
		} catch (error) {
			console.log(error);
			return {
				error: true,
			};
		}

		return {
			...data,
		};
	};

	updateNotificationStuff = async (
		cityId,
		// notificationPhones,
		settings,
	) => {
		// console.log("updateOperation", cityId, operating, notOperatingReason);
		let data;

		try {
			const res = await http.put(`${SETTINGS_URL}update-notification-stuff`, {
				cityId,
				...settings,
			});
			// console.log("res from put", res);
			data = res?.data;
		} catch (error) {
			console.log(error);
			return {
				error: true,
			};
		}

		return {
			...data,
		};
	};

	updateCatalog = async (cityId, catalog) => {
		let data;

		try {
			const res = await http.put(`${SETTINGS_URL}update-catalog`, {
				cityId,
				catalog,
			});
			// console.log("res from put", res);
			data = res?.data;
		} catch (error) {
			console.log(error);
			return {
				error: true,
			};
		}

		return {
			...data,
		};
	};

	// The areas drawn on the map (Ρυθμίσεις → Περιοχές). addAreas are new names,
	// appended to the city's list; areaBoundaries is the whole set of shapes.
	updateAreaBoundaries = async (cityId, { addAreas, areaBoundaries }) => {
		let data;

		try {
			const res = await http.put(`${SETTINGS_URL}update-area-boundaries`, {
				cityId,
				addAreas,
				areaBoundaries,
			});
			data = res?.data;
		} catch (error) {
			console.log(error);
			return {
				error: true,
			};
		}

		return {
			...data,
		};
	};

	// Colour zones (Ρυθμίσεις → Χρωματιστές ζώνες): the whole list of
	// [{ color, path }] at once. Unrelated to the areas above.
	updateColorZones = async (cityId, colorZones) => {
		let data;

		try {
			const res = await http.put(`${SETTINGS_URL}update-color-zones`, {
				cityId,
				colorZones,
			});
			data = res?.data;
		} catch (error) {
			console.log(error);
			return {
				error: true,
			};
		}

		return {
			...data,
		};
	};

	// The area under a point, decided the way order creation decides it
	// (an admin's remembered correction first, then the drawn shapes). cityId
	// matters only for a master; everyone else is held to their own city.
	getAreaForLocation = async (lat, lng, cityId) => {
		try {
			const res = await http.get(`${SETTINGS_URL}area-for-location`, { lat, lng, cityId });
			return res?.data;
		} catch (error) {
			console.log(error);
			return { error: true };
		}
	};

	// Trial mode: orders whose area differs from their pin's, between two times.
	getAreaMismatches = async (from, to, cityId) => {
		try {
			const res = await http.get(`${SETTINGS_URL}area-mismatches`, { from, to, cityId });
			return res?.data;
		} catch (error) {
			console.log(error);
			return { error: true };
		}
	};

	// The admins' corrections remembered per client pin.
	getAreaPins = async cityId => {
		try {
			const res = await http.get(`${SETTINGS_URL}area-pins`, { cityId });
			return res?.data;
		} catch (error) {
			console.log(error);
			return { error: true };
		}
	};

	deleteAreaPin = async (id, cityId) => {
		try {
			const res = await http.delete(`${SETTINGS_URL}area-pins/${id}?cityId=${cityId ?? ''}`);
			return res?.data;
		} catch (error) {
			console.log(error);
			return { error: true };
		}
	};

	// Deletes an area, its shape, and its price from every shop of the city.
	deleteArea = async (cityId, name) => {
		try {
			const res = await http.put(`${SETTINGS_URL}delete-area`, { cityId, name });
			return res?.data;
		} catch (error) {
			console.log(error);
			return { error: true };
		}
	};

	agreeToTerms = async () => {
		let data;

		try {
			const res = await http.put(`${PROFILE_URL}agree-to-terms`);
			// console.log("res from put", res);
			data = res?.data;
		} catch (error) {
			console.log(error);
			return {
				error: true,
			};
		}

		return {
			...data,
		};
	};

	// Google bills every map the browser opens. Reports one so the server can
	// count them per account and screen (`page`: live, pin, shops, areas, zones,
	// simulator). Fire-and-forget: a failure only means one load goes uncounted.
	countMapLoad = page => {
		http.post(`${PROFILE_URL}map-loaded`, { page }).catch(() => {});
	};

	subscribe = async subscription => {
		let data;

		try {
			const res = await http.post(`${PROFILE_URL}subscribe`, { subscription });
			// console.log("res from put", res);
			data = res?.data;
		} catch (error) {
			console.log(error);
			return {
				error: true,
			};
		}

		return {
			...data,
		};
	};

	unsubscribe = async subscription => {
		let data;

		try {
			const res = await http.post(`${PROFILE_URL}unsubscribe`, { subscription });
			// console.log("res from put", res);
			data = res?.data;
		} catch (error) {
			console.log(error);
			return {
				error: true,
			};
		}

		return {
			...data,
		};
	};

	getAutocomplete = async (input, searchOptions) => {
		// console.log("getAllCities");
		let data;

		try {
			const res = await http.get(`${PROFILE_URL}get-autocomplete`, { input, searchOptions });
			//   console.log(res);
			data = res?.data;
		} catch (error) {
			console.log(error);
			return {
				error: true,
			};
		}

		return {
			predictions: data?.predictions,
		};
	};

	geocodeByAddress = async prediction => {
		// console.log("getAllCities");
		let data;

		try {
			const res = await http.get(`${PROFILE_URL}geocode-by-address/${prediction}`);
			//   console.log(res);
			data = res?.data;
		} catch (error) {
			console.log(error);
			return {
				error: true,
			};
		}

		return {
			results: data?.results,
		};
	};
}

const profileController = new ProfileController();

export default profileController;
